import { render } from "./custom-account.vue?vue&type=template&id=5bf20d15"
import script from "./custom-account.vue?vue&type=script&lang=js"
export * from "./custom-account.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__